<template>
  <LogoLink :default-to="{ name: 'Login' }">
    <InterfaceSlot name="Logo" location="auth">
      <span class="flex items-center space-x-1 pt-8 sm:justify-start sm:pt-0 text-xl text-gray-800 font-bold">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" />
        </svg>
        <span>Vue Laravel SPA</span>
      </span>
    </InterfaceSlot>
  </LogoLink>
</template>

<script setup>
import InterfaceSlot from '@/components/InterfaceSlot.js'
import LogoLink from './LogoLink.vue'

defineOptions({ name: 'ApplicationLogo' })
</script>
